import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useEffect, useState } from "react";
import { COPY } from "@/copy";
import { DEFAULT_CONTENT } from "@/siteContent";
import { useReveal } from "@/useReveal";
import { AdminPage } from "@/AdminPage";
import { SiteHeader } from "@/SiteHeader";
import { HeroSection } from "@/HeroSection";
import { Marquee } from "@/Marquee";
import { ServicesSection } from "@/ServicesSection";
import { ManifestoSection } from "@/ManifestoSection";
import { CrewEquipmentSection } from "@/CrewEquipmentSection";
import { WorkGallerySection } from "@/WorkGallerySection";
import { QuoteSection } from "@/QuoteSection";
import { SiteFooter } from "@/SiteFooter";
import "@/App.css";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function HomePage() {
  const [language, setLanguage] = useState("en");
  const [content, setContent] = useState(DEFAULT_CONTENT);
  const copy = COPY[language];
  useReveal();
  useEffect(() => {
    fetch(`${API}/site-content`).then((response) => response.ok ? response.json() : null).then((data) => data && setContent(data)).catch(() => undefined);
  }, []);
  const scrollToQuote = () => document.getElementById("quote")?.scrollIntoView({ behavior: "smooth" });
  return <div className="site-shell"><SiteHeader copy={copy} content={content} language={language} onLanguageChange={() => setLanguage((current) => current === "en" ? "es" : "en")} onQuote={scrollToQuote} /><main id="top"><HeroSection copy={copy} content={content} language={language} onQuote={scrollToQuote} /><Marquee copy={copy} /><ServicesSection copy={copy} content={content} language={language} /><ManifestoSection copy={copy} /><WorkGallerySection copy={copy} content={content} language={language} /><CrewEquipmentSection copy={copy} content={content} language={language} /><QuoteSection copy={copy} content={content} language={language} /></main><SiteFooter copy={copy} content={content} /></div>;
}

function App() {
  return <BrowserRouter><Routes><Route path="/admin" element={<AdminPage />} /><Route path="*" element={<HomePage />} /></Routes></BrowserRouter>;
}

export default App;
